import { useCallback } from 'react';

import { useHandleError } from '@dotfile/frontend/shared/components';
import { useRefreshUrlElectronicSignatureCheckMutation } from '@dotfile/shared/data-access-client-portal';

export const useRefreshUrl = () => {
  const handleError = useHandleError();

  const [refreshUrlMutation, { loading }] =
    useRefreshUrlElectronicSignatureCheckMutation();

  const refreshUrl = useCallback(
    async ({ checkId }: { checkId: string }) => {
      try {
        await refreshUrlMutation({
          variables: {
            input: {
              checkId,
            },
          },
        });
        return true;
      } catch (error) {
        handleError({
          title: 'Failed to refresh signature URL',
          error,
        });
      }
      return false;
    },
    [refreshUrlMutation, handleError],
  );

  return {
    refreshUrl,
    loading,
  };
};
